import { useEffect, useState } from "react";
import { db } from "../services/firebase";
import { ref, onValue, off } from "firebase/database";

/**
 * Fetches all packs under `/Packs/{domainId}` to show to user
 */
export default function useFetchPacks(domainId) {
    const [packs, setPacks] = useState([]);
    const [loadingPacks, setLoading] = useState(true);

    useEffect(() => {
        if (!domainId) return;
        const packsRef = ref(db, `Packs/${domainId}`);

        const unsubscribe = onValue(packsRef, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                const list = Object.entries(data).map(([id, value]) => ({
                    id,
                    ...value,
                }));
                list.sort((a, b) => (a.orderId ?? 0) - (b.orderId ?? 0));
                setPacks(list);
            } else {
                setPacks([]);
            }
            setLoading(false);
        });

        return () => {
            off(packsRef);
            unsubscribe();
        };
    }, [domainId]);

    return { packs, loadingPacks };
}
